import { render, staticRenderFns } from "./shipout-req.vue?vue&type=template&id=3fb02914&scoped=true"
import script from "./shipout-req.vue?vue&type=script&lang=js"
export * from "./shipout-req.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb02914",
  null
  
)

export default component.exports